export default function () {
  /* 表格列头 */
  return [
    { type: "selection", width: 55 },
    { label: "序号", type: "index", width: 80 },
    { label: "模版ID", prop: "template_id", width: 200, slots: "template_id", },
    { label: "公众号用户openid", prop: "gzh_openid", width: 300 },
    { label: "发送方式", prop: "send_way", slots: "send_way", minWidth: 200 },
    { label: "发送结果", prop: "callback_msg", minWidth: 200 },
    {
      label: "发送时间",
      prop: "send_time",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 60,
      slots: "operation",
      fixed: "right",
    },
  ];
}
